import React from 'react';
import { DownloadIcon, GlobeIcon, LockIcon } from 'lucide-react';
const notes = [{
  label: '100% secure, encrypted checkout',
  Icon: LockIcon
}, {
  label: 'Payment processed in your local currency',
  Icon: GlobeIcon
}, {
  label: 'Instant digital access after purchase',
  Icon: DownloadIcon
}];

/** Reassurance shown right under the checkout button. */
export function SecurePaymentNote({
  className = ''
}: {
  className?: string;
}) {
  return <ul role="list" className={`mx-auto flex w-full max-w-[420px] flex-col gap-2.5 rounded-[14px] border border-brand-cta/25 bg-brand-cta/[0.06] px-5 py-4 text-left ${className}`} data-id="element-197" data-mp="1m76ib131lgdx">
      {notes.map(({
      label,
      Icon
    }) => <li key={label} className="flex items-center gap-2.5 font-body text-[13px] font-semibold text-brand-charcoal" data-id="element-198" data-mp="1zyjutv2j9dzg">
          <Icon className="h-4 w-4 flex-none text-brand-cta" strokeWidth={2} aria-hidden="true" data-id="element-199" data-mp="24ypkj5p8sqew" />
          {label}
        </li>)}
    </ul>;
}